import { render, staticRenderFns } from "./ClubsGuide.vue?vue&type=template&id=24618c55&scoped=true"
import script from "./ClubsGuide.vue?vue&type=script&lang=js"
export * from "./ClubsGuide.vue?vue&type=script&lang=js"
import style0 from "./ClubsGuide.vue?vue&type=style&index=0&id=24618c55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24618c55",
  null
  
)

export default component.exports